import { Component } from "react";
import loginStyles from "./login.module.css";
import axios from "axios";

class Login extends Component {
    title = 'Admin Login'

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: ''
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        axios.post('/api/login', {
            username: this.state.username,
            password: this.state.password
        })
            .then(response => {
                // handle successful login here
            })
            .catch(error => {
                this.setState({
                    error: 'Invalid username or password'
                });
            });
    }

    renderForm() {
        return (
            <div className={`light-bg d-flex justify-content-center py-5 text-dark`}>
                <div className={`d-flex ${loginStyles.mobile_wrapper}`}>
                    <div>
                        <form onSubmit={this.handleSubmit}>
                            <div>
                                <label>
                                    Username:
                                    <input type="text" name="username" value={this.state.username} onChange={this.handleInputChange} />
                                </label>
                            </div>
                            <div>
                                <label>
                                    Password:
                                    <input type="password" name="password" value={this.state.password} onChange={this.handleInputChange} />
                                </label>
                            </div>
                            {this.state.error && <div>{this.state.error}</div>}
                            <button type="submit">Log in</button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
    render() {
        return (
            <section class="mt-navbar">
                {this.renderForm()}
            </section>
        )
    }
}

export default Login;